import { Container, i18n, Table, TableRow, TimeSpecificFilters, utils, http } from "@common";
import { useRef, useCallback } from 'react';
import { SuspiciousActivityLevelOptions, DateRangeFilter } from "../../constant";
import { adminService } from "@api";

const SuspiciousActivity = () => {
    const tableRef = useRef();

    const filter = {
        items: [
            {
                id: 'filter-suspicious-activity-date-range',
                field: 'DateRange',
                title: i18n.get('CIS_Admin_Common_DateRange_Entry'),
                component: TimeSpecificFilters
            },
            {
                id: 'filter-suspicious-activity-status',
                field: 'RiskLevel',
                title: i18n.get('CIS_Admin_Reporting_SuspiciousActivity_Filter_RiskLevel_Entry'),
                items: SuspiciousActivityLevelOptions
            },
        ],
        params: { DateRange: DateRangeFilter.Last7days },
        search: { id: 'search-suspicious-activity', placeholder: i18n.get('CIS_Admin_Reporting_SuspiciousActivity_Search_Entry') },
    };

    const doDownload = useCallback(() => {
        $$.loading(true);
        const exportInfo = tableRef.current.getExportInfo();
        exportInfo.pageIndex = 0;
        exportInfo.pageSize = 0;
        exportInfo['timeZone'] = new Date().getTimezoneOffset() / -60;
        adminService.suspiciousDownload(exportInfo).then(() => {
            return true;
        }).catch((e) => {
            if (e?.errorCode === http.ErrorCode.CatchErrorCode) {
                $$.loading(false);
                $$.toast(e?.message, 'warning');
            }
        }).finally(() => {
            $$.loading(false);
        });
    }, []);

    const buttons = [
        {
            id: "btn-suspicious-activity-download",
            text: i18n.get('CIS_Admin_Common_Download_Entry'),
            classify: 'info',
            onClick: () => doDownload()
        },
    ];

    const columns = [
        { header: i18n.get('CIS_Admin_Reporting_SuspiciousActivity_OccurredTime_Entry'), sortable: -1, valuePath: 'OccurredTime' },
        { header: i18n.get('CIS_Admin_Reporting_SuspiciousActivity_Username_Entry'), sortable: true, valuePath: 'Username' },
        { header: i18n.get('CIS_Admin_Reporting_SuspiciousActivity_Application_Entry') },
        { header: i18n.get('CIS_Admin_Reporting_SuspiciousActivity_IPAddress_Entry') },
        { header: i18n.get('CIS_Admin_Reporting_SuspiciousActivity_Location_Entry') },
        { header: i18n.get('CIS_Admin_Reporting_SuspiciousActivity_RiskState_Entry') },
        { header: i18n.get('CIS_Admin_Reporting_SuspiciousActivity_RiskLevel_Entry') },
    ];

    const onLoadData = useCallback((info) => {
        info['timeZone'] = new Date().getTimezoneOffset() / -60;
        return adminService.suspiciousPaging(info).catch((e) => {
            if (e?.errorCode === http.ErrorCode.CatchErrorCode) {
                $$.loading(false);
                $$.toast(e?.message, 'warning');
            }
        });
    }, []);

    return (
        <Container>
            <Table
                id="table-suspicious-activity"
                ref={tableRef}
                onLoadData={onLoadData}
                rowTemplate={TableRowTemp}
                columns={columns}
                buttons={buttons}
                filter={filter}
                sort={{ name: 'OccurredTime', status: 'desc' }}
            />
        </Container>
    );
};
class TableRowTemp extends TableRow {
    render(Row, Cell) {
        const { occuredTime, userName, application, ipAddress, location, riskState, riskLevel } = this.props.rowData;
        return (
            <Row action={this.action}>
                <Cell>{utils.formatDateTime(occuredTime, true, true)}</Cell>
                <Cell>{userName || i18n.get('Common_NA_Entry')}</Cell>
                <Cell>{application || i18n.get('Common_NA_Entry')}</Cell>
                <Cell>{ipAddress || i18n.get('Common_NA_Entry')}</Cell>
                <Cell>{location || i18n.get('Common_NA_Entry')}</Cell>
                <Cell>{riskState || i18n.get('Common_NA_Entry')}</Cell>
                <Cell>{riskLevel || i18n.get('Common_NA_Entry')}</Cell>
            </ Row>
        );
    }
}

export default SuspiciousActivity;